<template>
  <div class="game-introduction" v-if="active">
    <div class="inner">
      <p>森林においては、林冠（りんかん）と呼ばれる森林の最上部から、林床（りんしょう）と呼ばれる地面に近い層まで、多様な植物が階層を成しています。</p>
      <p>林冠に近い層（高木層）では陽生植物と呼ばれる、日のよく当たる場所でよく育つ植物が多くなる傾向にあります。一方、林床に近い層（低木層）では陰生植物と呼ばれる、比較的光の弱いところでも育つ植物が多くなる傾向にあります。</p>
      <p>なぜ森林では層によって分布が異なるのでしょうか？ 樹木のない荒野から草原、低木林を経て森林が形成される過程を体験してみましょう。</p>
      <p class="notice" v-if="portraitMode"><strong>※画面を横向きにしてプレイすることを推奨しています</strong></p>
      <a class="button btn-normal" @click="close">スタート（ノーマルモード）</a>
      <a class="button btn-ranking">炭素固定量ランキングモード（準備中）</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GameIntroduction',
  data() {
    return {
      active: true,
    };
  },
  computed: {
    portraitMode: () => {
      return window.innerWidth < window.innerHeight;
    },
  },
  created() {
    this.$store.dispatch('stopGame');
  },
  methods: {
    close() {
      this.$store.dispatch('restartGame');
      this.active = false;
    },
  },
};
</script>

<style scoped lang="scss">
.game-introduction {
  z-index: 1000;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  box-sizing: border-box;

  .inner {
    position: absolute;
    top: 50%;
    left: 50%;
    min-width: 90%;
    max-height: 95%;
    padding: 1em 3em;
    text-align: left;
    background: #555;
    border-radius: 30px;
    font-size: 0.8rem;
    line-height: 1.6em;
    box-sizing: border-box;
    transform: translate(-50%, -50%);
  }

  .button {
    display: block;
    max-width: 280px;
    margin: 20px auto 0;
    padding: 20px;
    text-align: center;
    background: #0a5;
    color: #fff;
    border-radius: 20px;
    cursor: pointer;

    &:hover {
      opacity: 0.5;
    }
    &.btn-ranking {
      background: #888;
      color: #aaa;
    }
  }

  .notice {
    text-align: center;
    font-size: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/game/GameIntroduction.vue